import { render, staticRenderFns } from "./FormularioTerminadoView.vue?vue&type=template&id=0a546b59&"
import script from "./FormularioTerminadoView.vue?vue&type=script&lang=ts&"
export * from "./FormularioTerminadoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports